import {API, Get, makeSearchParams} from "./index";

let ordersController;

const GetOrders = (offset,limit, onlyVehicles = true) => {
    if (ordersController) {
        ordersController.abort("deduplication")
    }
    ordersController = new AbortController()
    return Get("orders", {offset, limit, only_vehicles: onlyVehicles}, ordersController.signal)
}

export {GetOrders}
